import { render, staticRenderFns } from "./LocusZoomComputedCredibleSetsPanel.vue?vue&type=template&id=79512a24&"
import script from "./LocusZoomComputedCredibleSetsPanel.vue?vue&type=script&lang=js&"
export * from "./LocusZoomComputedCredibleSetsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79512a24')) {
      api.createRecord('79512a24', component.options)
    } else {
      api.reload('79512a24', component.options)
    }
    module.hot.accept("./LocusZoomComputedCredibleSetsPanel.vue?vue&type=template&id=79512a24&", function () {
      api.rerender('79512a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lz/panels/LocusZoomComputedCredibleSetsPanel.vue"
export default component.exports